import React from "react";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { withTranslation } from "react-i18next";

import axios from "../../components/Axios";

// email languages, in their own names
const LANGUAGES = [
  ["en", "English"],
  ["fr", "Français"],
];

// Account > Profile: name, email, email language, and an inline password change
class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      name: "",
      email: "",
      language: "en",
      pwOpen: false,
      old_password: "",
      password: "",
      errorMessage: "",
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.getItems();
  }

  async getItems() {
    this.setState({ loading: true });
    try {
      let resp = await axios.get("/user/account");
      this.setState({
        name: resp.data.user_name,
        email: resp.data.email,
        language: resp.data.language,
      });
    } finally {
      this.setState({ loading: false });
    }
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  setLanguage = (language) => this.setState({ language });

  saveItem = async () => {
    this.setState({ loading: true });
    try {
      let resp = await axios.post("/user/account", {
        name: this.state.name,
        email: this.state.email,
        language: this.state.language,
      });
      this.setState({
        name: resp.data.user_name,
        email: resp.data.email,
        language: resp.data.language,
      });
      window.dispatchEvent(new CustomEvent("app-success", { detail: this.props.t("Profile saved") }));
    } finally {
      this.setState({ loading: false });
    }
  };

  openPassword = () => this.setState({ pwOpen: true, old_password: "", password: "", errorMessage: "" });

  closePassword = () => this.setState({ pwOpen: false, old_password: "", password: "", errorMessage: "" });

  changePassword = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    try {
      await axios.post("/user/password", {
        old_password: this.state.old_password,
        password: this.state.password,
      });
      this.setState({ loading: false });
      this.closePassword();
      window.dispatchEvent(new CustomEvent("app-success", { detail: this.props.t("Password changed") }));
    } catch (error) {
      this.setState({ loading: false });
      const data = error.response && error.response.data;
      if (data && "message" in data) this.setState({ errorMessage: data.message });
    }
  };

  render() {
    const { t } = this.props;
    const { loading, pwOpen } = this.state;
    return (
      <div className="ac-grid">
        <section className="ac-card ac-w3" aria-labelledby="ac-profile-h">
          <div className="ac-head">
            <h2 id="ac-profile-h" className="ac-title">
              {t("Profile")}
            </h2>
          </div>
          <div className="ac-body">
            <div className="ac-row">
              <label htmlFor="ac-name" className="ac-label">
                {t("Name")}
              </label>
              <input id="ac-name" name="name" type="text" autoComplete="name" className="ac-input" value={this.state.name || ""} onChange={this.handleChange} />
            </div>
            <div className="ac-row">
              <label htmlFor="ac-email" className="ac-label">
                {t("Email address")}
              </label>
              <input id="ac-email" name="email" type="email" autoComplete="email" className="ac-input" value={this.state.email || ""} onChange={this.handleChange} />
            </div>
            <div className="ac-row">
              <span id="ac-language-l" className="ac-label">
                {t("Preferred Email Language")}
              </span>
              <div className="ac-segs" role="group" aria-labelledby="ac-language-l">
                {LANGUAGES.map(([v, label]) => (
                  <button key={v} type="button" className="ac-seg" aria-pressed={this.state.language === v} onClick={() => this.setLanguage(v)}>
                    {label}
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div className="ac-foot">
            <Button className="Button ButtonPrimary ac-btn" onClick={this.saveItem} disabled={loading}>
              {t("Save")}
            </Button>
          </div>
        </section>

        <section className="ac-card ac-w2" aria-labelledby="ac-password-h">
          <div className="ac-head">
            <h2 id="ac-password-h" className="ac-title">
              {pwOpen ? t("Change Password") : t("Password")}
            </h2>
            <span className="ac-spacer" />
            {pwOpen ? (
              <button type="button" className="ac-sq ac-collapse" title={t("Collapse")} aria-label={t("Collapse")} onClick={this.closePassword}>
                <ExpandLessIcon />
              </button>
            ) : (
              <Button className="Button ButtonSecondary ac-btn" onClick={this.openPassword} disabled={loading}>
                {t("Change")}
              </Button>
            )}
          </div>
          {pwOpen && (
            <form onSubmit={this.changePassword}>
              <div className="ac-body">
                <div className="ac-row">
                  <label htmlFor="ac-old-password" className="ac-label ac-narrow">
                    {t("Current Password")}
                  </label>
                  <input
                    id="ac-old-password"
                    name="old_password"
                    type="password"
                    autoComplete="current-password"
                    className="ac-input"
                    value={this.state.old_password}
                    onChange={this.handleChange}
                    autoFocus
                  />
                </div>
                <div className="ac-row">
                  <label htmlFor="ac-new-password" className="ac-label ac-narrow">
                    {t("New Password")}
                  </label>
                  <input
                    id="ac-new-password"
                    name="password"
                    type="password"
                    autoComplete="new-password"
                    className="ac-input"
                    value={this.state.password}
                    onChange={this.handleChange}
                  />
                </div>
                {this.state.errorMessage !== "" && (
                  <Alert severity="error" onClose={() => this.setState({ errorMessage: "" })}>
                    {this.state.errorMessage}
                  </Alert>
                )}
              </div>
              <div className="ac-foot">
                <Button className="Button ac-btn" onClick={this.closePassword}>
                  {t("Cancel")}
                </Button>
                <Button type="submit" className="Button ButtonPrimary ac-btn" disabled={loading}>
                  {t("Save")}
                </Button>
              </div>
            </form>
          )}
        </section>
      </div>
    );
  }
}

export default withTranslation()(Index);
